import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

interface Props {
  title: string;
  value: React.ReactNode;
  subtitle?: string;
  trend?: number[]; // small sparkline data
  accent?: 'primary' | 'success' | 'warning' | 'neutral';
}

const accentColors: Record<string, string> = {
  primary: '#06b6d4',
  success: '#10b981',
  warning: '#f59e0b',
  neutral: '#64748b'
};

const AdminStatsCard: React.FC<Props> = ({ title, value, subtitle, trend, accent = 'neutral' }) => {
  return (
    <div className="admin-card modern">
      <div className="admin-card-top">
        <div className="admin-card-title">{title}</div>
        <div className="admin-card-value">{value}</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
        <div className="admin-card-sub">{subtitle}</div>
        {trend && trend.length > 0 && (
          <div style={{ width: 120, height: 40 }} aria-hidden className="tooltip">
            <ResponsiveContainer>
              <LineChart data={trend.map((v, i) => ({ i, v }))}>
                <Line type="monotone" dataKey="v" stroke={accentColors[accent]} strokeWidth={2} dot={false} isAnimationActive={true} animationDuration={600} />
              </LineChart>
            </ResponsiveContainer>
            <span className="tooltip-text">Último: R$ {Number(trend[trend.length-1] || 0).toLocaleString('pt-br', { minimumFractionDigits: 2 })}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminStatsCard;
